import{L as o,d as s}from"./loading-spinner2.js";const n=o,r=s;export{n as LoadingSpinner,r as defineCustomElement}